import "./image-zoom.scss";

import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";

const overlayHtml = `<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
<div class="pswp__bg"></div>
<div class="pswp__scroll-wrap">
    <div class="pswp__container">
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
    </div>
    <div class="pswp__ui pswp__ui--hidden">
        <div class="pswp__top-bar">
            <div class="pswp__counter"></div>
            <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
            <button class="pswp__button pswp__button--share" title="Share"></button>
            <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
            <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
            <div class="pswp__preloader">
                <div class="pswp__preloader__icn">
                    <div class="pswp__preloader__cut">
                        <div class="pswp__preloader__donut"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
            <div class="pswp__share-tooltip"></div>
        </div>
        <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
        </button>
        <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
        </button>
        <div class="pswp__caption">
            <div class="pswp__caption__center"></div>
        </div>
    </div>
</div>
</div>`;

const template = document.createElement("template");

template.innerHTML = overlayHtml;

const overlay = template.content.firstChild;

document.body.appendChild(overlay);

const zoomLinks = [...document.querySelectorAll(".image-zoom")];

const images = [];

zoomLinks.forEach((link, index) => {
  var imgData = JSON.parse(link.dataset.pswp);
  images.push(imgData);

  link.addEventListener(
    "mouseenter",
    () => {
      var img = new Image();
      img.src = imgData.msrc;
    },
    { once: true }
  );

  link.onclick = (e) => {
    e.preventDefault();

    new PhotoSwipe(overlay, PhotoSwipeUI_Default, images, {
      shareEl: false,
      index: index,
      showHideOpacity: true,
    }).init();
  };
});
